import angular from 'angular';
import mergeContactButton from './mergeContactButton';

export default angular
  .module('mergeContact.components', [])
  .component('mergeContactButton', mergeContactButton).name;
